<script>
export default {
  data () {
    return {
      instantData: {},
      interval: null,
      lastTs: 0
    }
  },
  mounted () {
    this.updateData()
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.$api.getTs({
          collection: 'meter_stable_data',
          sn: this.$store.state.sn
        }).then((res) => {
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg)
            return
          }
          if (this.lastTs !== res.data.data.ts) {
            this.lastTs = res.data.data.ts
            this.updateData()
          }
        })
      }, 1000)
    }
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  },
  methods: {
    async updateData () {
      const params = {
        'collection': 'meter_stable_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'fields': ['sta', 'stb', 'stc']
      }
      const {data: res} = await this.$api.queryLastData(params)
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      this.instantData = res.data
      // console.log('aaa', res.data)
    }
  }
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">瞬时闪变</div>
      <div style="height: calc(100% - 50px); width: 100%">
        <div
          style="height: calc(100% / 3); width: 60%; margin-left: 20%; display: flex; justify-content: space-around; align-items: center; border-bottom: 1px solid #b4b4b4;">
          <div>A相瞬时闪变</div>
          <div>{{ Number(instantData ? instantData.sta : 0).toFixed(3) }}</div>
        </div>
        <div
          style="height: calc(100% / 3); width: 60%; margin-left: 20%; display: flex; justify-content: space-around; align-items: center; border-bottom: 1px solid #b4b4b4;">
          <div>B相瞬时闪变</div>
          <div>{{ Number(instantData ? instantData.stb : 0).toFixed(3) }}</div>
        </div>
        <div
          style="height: calc(100% / 3); width: 60%; margin-left: 20%; display: flex; justify-content: space-around; align-items: center">
          <div>C相瞬时闪变</div>
          <div>{{ Number(instantData ? instantData.stc : 0).toFixed(3) }}</div>
        </div>
      </div>
      <!--      <div class="dataItem">-->
      <!--        <div class="dataName">-->
      <!--          <div class="dataNvItem" style="min-width: 100px">A相瞬时闪变</div>-->
      <!--          <div class="dataNvItem" style="min-width: 100px">B相瞬时闪变</div>-->
      <!--          <div class="dataNvItem" style="min-width: 100px">C相瞬时闪变</div>-->
      <!--        </div>-->
      <!--        <div class="dataValue">-->
      <!--          <div class="dataNvItem">0.000</div>-->
      <!--          <div class="dataNvItem">0.000</div>-->
      <!--          <div class="dataNvItem">0.000</div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

.pg {
  height: calc(45vh - 50px);
}

</style>



// WEBPACK FOOTER //
// src/pages/Transient/InstantFlicker/InstantFlicker.vue